import axios from "axios";

import { getToken } from "@/utils/tokenStorage";

const API = "/api";
const cfg = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

export const listarClassificacoes = () => axios.get(`${API}/expense-classifications`, cfg()).then((r) => r.data || []);
export const criarClassificacao = (nome, natureza) =>
  axios.post(`${API}/expense-classifications`, { name: nome, nature: natureza }, cfg()).then((r) => r.data);

// A lista inteira só serve para sugerir fornecedores já usados (mesma regra da tela antiga).
export const listarDespesas = () => axios.get(`${API}/expenses`, cfg()).then((r) => r.data || []);
export const obterDespesa = (id) => axios.get(`${API}/expenses/${encodeURIComponent(id)}`, cfg()).then((r) => r.data);
export const salvarDespesa = (id, dados) => (id
  ? axios.put(`${API}/expenses/${encodeURIComponent(id)}`, dados, cfg())
  : axios.post(`${API}/expenses`, dados, cfg())).then((r) => r.data);
